import { HttpClient } from '@angular/common/http';
import { Injectable } from '@angular/core';
import { ExecutionResult, LcsApiService } from '@lcs/shared/api';
import { ExtensionGroupInput } from 'generated/graphql-types';
import { Observable } from 'rxjs';
import { extensionGroupMemberKeyFields } from '../models/extension-goup-member-item.model';
import {
   ExtensionGroupDetailSaveModel,
   ExtensionGroupExtensionSaveModel,
} from '../models/extension-group-detail-save.model';
import { ExtensionGroupDetailView } from '../models/extension-group-detail-view.model';
import { deleteExtensionGroupMutation } from '../queries/delete-extension-group.graphql';
import { DeleteExtensionGroupVariables } from '../queries/generated/DeleteExtensionGroup';
import { GetExtensionGroupDetail_extensionGroup_extensionGroupExtensionsConnection_items } from '../queries/generated/GetExtensionGroupDetail';
import { SaveExtensionGroup, SaveExtensionGroupVariables } from '../queries/generated/SaveExtensionGroup';
import { SaveExtensionGroupMutation } from '../queries/save-extension-group.graphql';

@Injectable({ providedIn: 'root' })
export class ExtensionGroupDetailApiService {
   constructor(private apiService: LcsApiService, private http: HttpClient) {}
   save(
      extensionGroupDetail: ExtensionGroupDetailSaveModel,
      extensionGroupFields: (keyof ExtensionGroupInput)[],
      existingExtensionGroup?: ExtensionGroupDetailView | null
   ): Observable<ExecutionResult<SaveExtensionGroup>> {
      let deletedExtensionGroupExtensionMemberIds: number[] = [];
      if (extensionGroupFields) {
         extensionGroupFields = [...extensionGroupFields, 'extensionGroupId'];
         this.formatExtensionGroupFields('extensionGroup', extensionGroupFields);
      }
      deletedExtensionGroupExtensionMemberIds = this.getDeletedExtensionGroupExtensionMemberIds(
         extensionGroupDetail.extensionGroupExtensions ?? null,
         existingExtensionGroup?.extensions?.items ?? null
      );
      return this.apiService.query<SaveExtensionGroup, SaveExtensionGroupVariables>({
         query: SaveExtensionGroupMutation,
         variables: {
            hasDeletedExtensionGroupExtensionMembers: deletedExtensionGroupExtensionMemberIds.length > 0,
            deletedExtensionGroupExtensionMemberIds,
            extensionGroup: {
               ...extensionGroupDetail,
               fields: extensionGroupFields,
            },
         },
      });
   }

   deleteExtensionGroup(extensionGroupId: number): Observable<ExecutionResult<void>> {
      return this.apiService.query<void, DeleteExtensionGroupVariables>({
         query: deleteExtensionGroupMutation,
         variables: {
            extensionGroupId,
         },
      });
   }

   formatExtensionGroupFields = (key: string, embedFields: (keyof ExtensionGroupInput)[]) => {
      if (key) {
         const additionalFields: (keyof ExtensionGroupInput)[] = [];

         for (const embedField of embedFields) {
            if (embedField === 'extensionGroupExtensions') {
               additionalFields.push(
                  ...extensionGroupMemberKeyFields.map((keyField) => {
                     return `${embedField}.${keyField}` as keyof ExtensionGroupInput; // Ensure the type matches
                  })
               );
            }
         }
         embedFields.push(...additionalFields);
         const index = embedFields.indexOf('extensionGroupExtensions');
         embedFields.splice(index, 1);
      }
   };

   getDeletedExtensionGroupExtensionMemberIds = (
      currentExtensionGroupExtensionMembers: ExtensionGroupExtensionSaveModel[] | null,
      existingExtensionGroupExtensionMembers:
         | GetExtensionGroupDetail_extensionGroup_extensionGroupExtensionsConnection_items[]
         | null
   ): number[] => {
      if (!currentExtensionGroupExtensionMembers || !existingExtensionGroupExtensionMembers) {
         return [];
      }
      return existingExtensionGroupExtensionMembers
         .filter((egeMember) => {
            return !currentExtensionGroupExtensionMembers.some((currentHgMembers) => {
               return currentHgMembers.extensionGroupExtensionId === egeMember.extensionGroupExtensionId;
            });
         })
         .map((deletedEgeMember) => {
            return deletedEgeMember.extensionGroupExtensionId;
         });
   };
}
